var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import * as React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { utils } from '@rjsf/core';
import { useGetList, useReference } from 'react-admin';
var getDisplayLabel = utils.getDisplayLabel;
export var ReferenceWidget = function (props) {
    var value = props.value, label = props.label, schema = props.schema, onChange = props.onChange, uiSchema = props.uiSchema, required = props.required, rootSchema = props.rootSchema, options = props.options;
    var _a = React.useState(''), search = _a[0], setSearch = _a[1];
    var _b = options.pagination, pagination = _b === void 0 ? { page: 1, perPage: 25 } : _b, _c = options.sort, sort = _c === void 0 ? { field: 'id', order: 'DESC' } : _c, optionText = options.optionText, _d = options.filterToQuery, filterToQuery = _d === void 0 ? DefaultFilterToQuery : _d, reference = options.reference;
    // fetch choices
    var _e = useReference({
        id: value,
        reference: reference,
        options: {
            enabled: value != null && value !== '',
        },
    }), referenceRecord = _e.referenceRecord, isLoading = _e.isLoading;
    // fetch possible values
    var _f = useGetList(reference, {
        pagination: pagination,
        sort: sort,
        filter: filterToQuery(search),
    }).data, data = _f === void 0 ? [] : _f;
    var choices = !referenceRecord || data.some(function (record) { return record.id == referenceRecord.id; })
        ? data
        : __spreadArray([referenceRecord], data);
    // MUI Autocomplete, when controlled, uses the raw option as value.
    // As choices are objects (e.g. { id: 'foo', name: 'Foo' }),
    // then we must only provide the list of ids to the Autocomplete.
    // see https://github.com/mui/material-ui/issues/23708
    //
    // if choices = [{ id: '1', name: 'Foo' }, { id: '2', name: 'Bar' }];
    // choicesById = { '1': { id: '1', name: 'Foo' }, '2': { id: '2', name: 'Bar' } };
    var choicesById = choices.reduce(function (acc, choice) {
        acc[choice.id] = choice;
        return acc;
    }, {});
    // choiceValues = ['1', '2']
    var choiceValues = Object.keys(choicesById);
    var displayLabel = getDisplayLabel(schema, uiSchema, rootSchema);
    var getOptionLabel = React.useCallback(function (id) {
        var choice = choicesById[id];
        return choice ? choice[optionText] : String(id);
    }, [choicesById, optionText]);
    var renderOption = React.useCallback(function (props2, value) { return (React.createElement("li", __assign({}, props2, { key: value }), getOptionLabel(value))); }, [getOptionLabel]);
    var onInputChange = React.useCallback(function (_, newInputValue) {
        if (referenceRecord &&
            newInputValue !== referenceRecord[optionText]) {
            setSearch(newInputValue);
        }
    }, [referenceRecord, optionText]);
    return (React.createElement(Autocomplete, { value: value, loading: isLoading, selectOnFocus: true, clearOnBlur: true, handleHomeEndKeys: true, onChange: function (_, newValue) { return onChange(newValue); }, disablePortal: true, options: choiceValues.length === 0 ? [String(value)] : choiceValues, getOptionLabel: getOptionLabel, renderOption: renderOption, filterOptions: function (x) { return x; }, isOptionEqualToValue: function (option, value) { return option == value; }, onInputChange: onInputChange, renderInput: function (params) { return (React.createElement(TextField, __assign({ required: required, label: displayLabel ? label || schema.title : false, inputProps: {
                autoComplete: 'new-password', // disable autocomplete and autofill
            } }, params))); } }));
};
var DefaultFilterToQuery = function (searchText) {
    return searchText ? { q: searchText } : {};
};
